{
    "FormEngineRadiosElement": {
        "title": "Radios"
    },
    "mask": {
        "FormEngineRadiosElement": {
            "groupTitle": "Radios",
            "inline": "Inline",
            "datasource": "Options",
            "datasourceExpressions": "Options Filter"
        }
    }
}